import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class SimulatorQueryFilter extends QueryFilter{
  public organizationId: string;
}
